import React, { useEffect, useState } from "react";
import "../detailNewspage/styles/index.less";
import {
  Typography,
  Form,
  Layout,
  Row,
  Col,
  Input,
  Result,
  Button,
} from "antd";
import { useNavigate, useParams } from "react-router-dom";
import lock from "../../assets/iconshare/padlock.png";
import jwtDecode from "jwt-decode";
import { api_confirmNewPassword, user_create_login } from "../../services/user";
import { ArrowLeftOutlined } from "@ant-design/icons";

const { Title, Text, Paragraph } = Typography;
const { Content } = Layout;

type Props = {};

const ConfirmForgot = (props: Props) => {
  const navigate = useNavigate();
  const { token } = useParams();
  const [form] = Form.useForm();
  const [changeSuccess, setChangeSuccess] = useState(false);

  // useEffect(() => {
  //   if (id) {
  //     try {
  //       const decoded = jwtDecode(id);
  //       handleCreateUser(decoded);
  //     } catch (error) {
  //       // console.error('Invalid JWT token:', error);
  //     }
  //   }
  // }, [id]);

  const handleOnFinish = async (value: any) => {
    try {
      const data = {
        token: token,
        password: value.password,
      };
      const res = await api_confirmNewPassword(data);
      if (res.status === true) {
        setChangeSuccess(true);
      } else {
        setChangeSuccess(false);
      }
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <>
      {!changeSuccess ? (
        <div style={{ padding: "40px 0px 10px 0px" }}>
          <Row justify={"center"} align={"middle"}>
            <Col>
              <img src={lock} style={{ width: "100px", color: "#1890ff" }} />
            </Col>
          </Row>
          <Row justify={"center"} align={"middle"}>
            <Col>
              <p
                style={{
                  fontSize: "35px",
                  fontWeight: "bold",
                  marginTop: "10px",
                }}
              >
                Create New Password
              </p>
            </Col>
          </Row>
          <Form
            layout="vertical"
            form={form}
            name="login"
            initialValues={{
              autoLogin: true,
              email: "",
              password: "",
            }}
            onFinish={handleOnFinish}
          >
            <Row justify={"center"} align={"middle"}>
              <Col xs={16} sm={12} md={10} lg={6} xl={6}>
                <Form.Item
                  name="password"
                  label="New Password"
                  dependencies={["password"]}
                  rules={[
                    {
                      required: true,
                      message: "Please confirm your password!",
                    },
                    {
                      min: 8,
                      message: "Password must be at least 8 characters long!",
                    },
                  ]}
                >
                  <Input.Password placeholder="password" />
                </Form.Item>
              </Col>
            </Row>
            <Row justify={"center"} align={"middle"}>
              <Col xs={16} sm={12} md={10} lg={6} xl={6}>
                <Form.Item
                  name="confirm"
                  label="Confirm Password"
                  dependencies={["password"]}
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: "Please confirm your password!",
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("password") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error(
                            "The new password that you entered do not match!",
                          ),
                        );
                      },
                    }),
                  ]}
                >
                  <Input.Password placeholder="Your Confirm Password" />
                </Form.Item>
              </Col>
            </Row>

            <Row className="button-group" justify={"center"} align={"middle"}>
              {/* <Col>
              <Button
                type="default"
                htmlType="button"
                className="sign-up-form-button"
                onClick={() => navigate("/home")}
              >
                Cancel
              </Button>
            </Col> */}
              <Col xs={16} sm={12} md={10} lg={6} xl={6}>
                <Button
                  type="primary"
                  style={{
                    backgroundColor: "#0E21A0",
                    color: "white",
                    width: "100%",
                  }}
                  htmlType="submit"
                  className="sign-up-form-button"
                >
                  Reset Password
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      ) : (
        <div style={{ padding: "40px 0px 10px 0px" }}>
          <Result
            status="success"
            title="Password Reset!"
            subTitle={
              <span style={{ fontSize: "18px" }}>
                Your password has been successfully reset, Click below to
                continue your access
              </span>
            }
            extra={[
              <Button
                type="primary"
                key="console"
                style={{ backgroundColor: "#0E21A0" }}
                onClick={() => {
                  setChangeSuccess(false);
                  navigate("/");
                }}
              >
                <ArrowLeftOutlined /> Home Page
              </Button>,
            ]}
          />
        </div>
      )}
    </>
  );
};

export default ConfirmForgot;
